import axios from "axios";
import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Modal,
} from "react-bootstrap";
import { BsBank2, BsPersonCircle } from "react-icons/bs";
import { FiDollarSign } from "react-icons/fi";
import Swal from "sweetalert2";

function TransferenciasInternas() {
  const [cvu, setCvu] = useState("");
  const [monto, setMonto] = useState("");
  const [concepto, setConcepto] = useState("");
  const [cvuDestino, setCvuDestino] = useState("");

  const [error, setError] = useState("");

  const [showPreview, setShowPreview] = useState(false);

  const [usuarioDestino, setUsuarioDestino] = useState(null);

  // -------------------------
  // ENVIAR
  // -------------------------
  const [loadingConsultar, setLoadingConsultar] = useState(false);
  const handleEnviar = async () => {
    setError("");

    if (!cvu) {
      setError("Ingrese un CVU");
      return;
    }

    if (!monto || Number(monto) <= 0) {
      setError("Ingrese un monto válido");
      return;
    }

    if (!concepto) {
      setError("Seleccione un concepto");
      return;
    }

    try {
      setLoadingConsultar(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/public/Exists`,
        { cvuDest: cvu },
        {
          headers: {
            "SERVICIOS-URBANOS-TOKEN": localStorage.getItem("token"),
          },
        }
      );
      if (response.status === 200 && response.data.msg) {
        setUsuarioDestino(response.data.msg);
        setShowPreview(true);
        setCvuDestino(response.data.msg.cvu);
      }
    } catch (err) {
      setError(err.response?.data?.msg || "Error al obtener datos del usuario");
    } finally {
      setLoadingConsultar(false);
    }
  };

  // -------------------------
  // CONFIRMAR
  // -------------------------
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const handleConfirmarTransferencia = async () => {
    try {
      setLoadingConfirm(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/public/v2/Transfer`,
        {
          cvuDest: cvuDestino,
          amount: monto,
          concept: concepto,
        },
        {
          headers: {
            "SERVICIOS-URBANOS-TOKEN": localStorage.getItem("token"),
          },
        }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Transferencia exitosa",
          text: "La transferencia se realizó correctamente.",
        });
        setCvu("");
        setMonto("");
        setConcepto("");
        setUsuarioDestino(null);
        setShowPreview(false);
      }
    } catch (err) {
      setShowPreview(false);
      setError(err.response?.data?.msg || "Error al realizar la transferencia");
    } finally {
      setLoadingConfirm(false);
    }
  };

  return (
    <Container className="mt-4">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card
            className="border shadow-sm"
            style={{
              borderRadius: 18,
            }}
          >
            <Card.Body style={{ padding: 28 }}>
              <div className="mb-4">
                <h3
                  style={{
                    fontWeight: 700,
                    marginBottom: 4,
                  }}
                >
                  Nueva Transferencia
                </h3>

                <span
                  style={{
                    color: "#6c757d",
                    fontSize: 14,
                  }}
                >
                  Realizá transferencias entre cuentas
                </span>
              </div>

              {error && (
                <Alert
                  variant="danger"
                  style={{
                    borderRadius: 12,
                  }}
                >
                  {error}
                </Alert>
              )}

              {/* CVU */}
              <Form.Group className="mb-3">
                <Form.Label
                  style={{
                    fontWeight: 500,
                  }}
                >
                  CVU o Alias del destinatario
                </Form.Label>

                <Form.Control
                  type="text"
                  placeholder="Ingrese el CVU o Alias"
                  value={cvu}
                  onChange={(e) => setCvu(e.target.value)}
                  style={{
                    height: 48,
                    borderRadius: 12,
                  }}
                />
              </Form.Group>

              {/* MONTO */}
              <Form.Group className="mb-3">
                <Form.Label
                  style={{
                    fontWeight: 500,
                  }}
                >
                  Monto
                </Form.Label>

                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <FiDollarSign
                    size={18}
                    style={{
                      position: "absolute",
                      top: 15,
                      left: 12,
                      color: "#6c757d",
                    }}
                  />

                  <Form.Control
                    type="number"
                    placeholder="Ingrese un monto"
                    value={monto}
                    onChange={(e) => setMonto(e.target.value)}
                    style={{
                      height: 48,
                      borderRadius: 12,
                      paddingLeft: 38,
                    }}
                  />
                </div>
              </Form.Group>

              {/* CONCEPTO */}
              <Form.Group className="mb-4">
                <Form.Label
                  style={{
                    fontWeight: 500,
                  }}
                >
                  Concepto
                </Form.Label>

                <Form.Select
                  value={concepto}
                  onChange={(e) => setConcepto(e.target.value)}
                  style={{
                    height: 48,
                    borderRadius: 12,
                  }}
                >
                  <option value="">Seleccione un concepto</option>

                  <option value="ALQ">Alquiler</option>

                  <option value="CUO">Cuota</option>

                  <option value="EXP">Expensas</option>

                  <option value="FAC">Factura</option>

                  <option value="PRE">Préstamo</option>

                  <option value="SEG">Seguro</option>

                  <option value="HON">Honorarios</option>

                  <option value="HAB">Haberes</option>

                  <option value="VAR">Varios</option>
                </Form.Select>
              </Form.Group>

              <Button
                variant="primary"
                onClick={handleEnviar}
                className="button-confirm"
                disabled={loadingConsultar}
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 12,
                  fontWeight: 600,
                }}
              >
                {loadingConsultar ? "Consultando..." : "Continuar"}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* -------------------------
          MODAL PREVIEW
      ------------------------- */}
      <Modal show={showPreview} onHide={() => setShowPreview(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar transferencia</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {usuarioDestino && (
            <>
              {/* USUARIO */}
              <div
                style={{
                  background: "#FFF8F0",
                  borderRadius: 16,
                  padding: 20,
                  marginBottom: 18,
                  border: "1px solid #FFD8A8",
                  boxShadow: "0 2px 8px rgba(255, 170, 40, 0.08)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                  }}
                >
                  <div
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      background: "#FFE7C2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#D97706",
                    }}
                  >
                    <BsPersonCircle size={30} />
                  </div>

                  <div>
                    <h5
                      style={{
                        marginBottom: 2,
                        fontWeight: 700,
                        color: "#343a40",
                      }}
                    >
                      {usuarioDestino.name || ""}{" "}
                      {usuarioDestino.lastName || ""}
                    </h5>
                  </div>
                </div>

                <hr
                  style={{
                    borderColor: "#FFD8A8",
                    opacity: 0.7,
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      color: "#5C4B3B",
                    }}
                  >
                    <BsBank2 color="#D97706" />

                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      {usuarioDestino.bank || "Banco no especificado"}
                    </span>
                  </div>

                  <div
                    style={{
                      fontSize: 14,
                      color: "#7C6F64",
                    }}
                  >
                    Alias: {usuarioDestino.label || "No se encontró alias"}
                  </div>
                  <div
                    style={{
                      fontSize: 14,
                      color: "#7C6F64",
                    }}
                  >
                    CUIT: {usuarioDestino.cuit || "No se encontró CUIT"}
                  </div>
                  <div
                    style={{
                      fontSize: 14,
                      color: "#7C6F64",
                    }}
                  >
                    CVU: {usuarioDestino.cvu || "No se encontró CVU"}
                  </div>
                </div>
              </div>

              {/* DETALLE */}
              <div
                style={{
                  background: "#FFFFFF",
                  border: "1px solid #FFD8A8",
                  borderRadius: 16,
                  padding: 20,
                  boxShadow: "0 2px 8px rgba(255, 170, 40, 0.06)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      color: "#7C6F64",
                      fontWeight: 500,
                    }}
                  >
                    Total
                  </span>

                  <h3
                    style={{
                      margin: 0,
                      fontWeight: 700,
                      color: "#E67E22",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    ${Number(monto).toLocaleString("es-AR")}
                  </h3>
                </div>
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => setShowPreview(false)}
            style={{
              borderRadius: 10,
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="success"
            onClick={handleConfirmarTransferencia}
            style={{
              borderRadius: 10,
              fontWeight: 600,
            }}
            className="button-confirm"
            disabled={loadingConfirm}
          >
            {loadingConfirm ? "Procesando..." : "Confirmar transferencia"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default TransferenciasInternas;
